import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CrudService } from 'src/app/services/crud.service';

@Component({
  selector: 'app-ai-generate-image',
  templateUrl: './ai-generate-image.component.html',
  styleUrl: './ai-generate-image.component.css'
})
export class AiGenerateImageComponent {
  userPrompt: any;
  imageURL: any = '';
  spinner: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public readonly dialogRef: MatDialogRef<AiGenerateImageComponent>,
    private urlService: CrudService,
  ) {
  }

  sendPrompt() {
    this.spinner = true;
    this.urlService.createImage({ userPrompt: this.userPrompt }).subscribe(success => {
      this.spinner = false;
      this.imageURL = success.data;
    },
      (error) => {
        console.log(error);
      })
  }

  uploadImage() {
    this.dialogRef.close({ image: this.imageURL });
  }
}
